module.exports = __webpack_public_path__ + "img/20180815_150347_070.9680a92c.jpg";